import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/auth/auth.service';
import { FeedbackType } from 'src/app/general-components/feedback/feedback-type';
import { FeedbackSettings } from 'src/app/general-components/feedback/feedback-settings';
import { ProductImportReportService } from '../product-import-report.service';
import { ImportAreaReport } from '../product-import-report-types';
import { reportStatusBadgeClass, reportStatusLabel, toDisplayStatus } from '../product-import-report-status.util';

@Component({
  selector: 'app-product-import-area-history',
  templateUrl: './product-import-area-history.component.html',
  styleUrls: ['./product-import-area-history.component.scss'],
})
export class ProductImportAreaHistoryComponent implements OnInit {
  code: string = '';
  areaName: string = '';
  reports: ImportAreaReport[] = [];
  isLoading: boolean = false;

  hasProductFactoryAccess: boolean = false;
  cognitoGroups: string[] = [];

  feedbackSettings: FeedbackSettings = {
    identifier: '',
    show: false,
    type: FeedbackType.error,
    message: 'Er is iets misgegaan sorry',
    closeButton: false,
  };

  private readonly productFactoryGroupName = 'AWS-PF';
  private readonly reportLimit = 20;

  constructor(
    private service: ProductImportReportService,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.cognitoGroups = this.authService.getCognitoGroups();
    this.hasProductFactoryAccess = this.cognitoGroups.includes(this.productFactoryGroupName);

    this.code = this.route.snapshot.paramMap.get('code') ?? '';
    // The reports endpoint carries no display name; the board passes it as ?name=.
    // Falls back to the raw code on a bare deep link.
    this.areaName = this.route.snapshot.queryParamMap.get('name') ?? this.code;

    if (this.hasProductFactoryAccess && this.code) {
      this.loadReports();
    }
  }

  loadReports(): void {
    this.isLoading = true;
    this.service.getAreaReports(this.code, this.reportLimit).subscribe({
      next: (reports: ImportAreaReport[]) => {
        this.reports = reports;
        this.isLoading = false;
      },
      error: (error: Error) => {
        this.updateFeedback(
          FeedbackType.error,
          'Fout opgetreden bij het ophalen van de rapportgeschiedenis',
          false,
          'Terug naar hoofdmenu'
        );
        this.isLoading = false;
        console.error(error);
      },
    });
  }

  updateFeedback(
    type: FeedbackType,
    message: string,
    closeButton: boolean = true,
    buttonText: string | undefined = undefined
  ): void {
    this.feedbackSettings.identifier = '';
    this.feedbackSettings.show = true;
    this.feedbackSettings.closeButton = closeButton;
    this.feedbackSettings.buttonText = buttonText;
    this.feedbackSettings.type = type;
    this.feedbackSettings.message = message;
  }

  statusLabel(report: ImportAreaReport): string {
    return reportStatusLabel(toDisplayStatus(report.status, report.counts));
  }

  statusBadgeClass(report: ImportAreaReport): string {
    return reportStatusBadgeClass(toDisplayStatus(report.status, report.counts));
  }

  returnHome(): void {
    void this.router.navigate(['home']);
  }
}
